// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ip9Y","productName":"Table_productName__2_7XY"};